__turbopack_context__.v({
  "col": "ServiceColumns-module-scss-module__7OgWRW__col",
  "divider": "ServiceColumns-module-scss-module__7OgWRW__divider",
  "popoverInnerContent": "ServiceColumns-module-scss-module__7OgWRW__popoverInnerContent",
});
